import { AbstractListComponent } from '../../../shared/crud/component/list.component';
import { Subject } from 'rxjs';
import { EventBus, IEvent } from '../../../shared/event/bus';
import { ActivatedRoute, Router } from '@angular/router';
import { IConfirmationDialogPayload } from '../../../shared/ui/component/confirmation-dialog/confirmation-dialog-payload.interface';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AfterViewChecked, ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { UrlBuilder } from '../../../shared/crud/api/url-builder';

export abstract class AbstractPresetListComponent extends AbstractListComponent implements OnInit, OnDestroy, AfterViewChecked {

  protected currentPreset: any;
  protected defaultSubject: Subject<IConfirmationDialogPayload> = new Subject();

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              urlBuilder: UrlBuilder,
              protected eventBus: EventBus,
              protected changeDetector: ChangeDetectorRef) {
    super(httpClient, toastrService, router, route, urlBuilder);
  }

  ngOnInit(): void {
    this.parameters.limit = 999;
    super.ngOnInit();

    this.loadingPromise.add(() => {
      if (this.pagination && this.pagination.rows) {
        if (!this.route.firstChild) {
          for (const row of this.pagination.rows) {
            if (row.isDefault) {
              this.router.navigate([ './' + row.id ], { relativeTo: this.route });
              this.currentPreset = row.id;
            }
          }
        } else {
          this.currentPreset = (<any>this.route.firstChild.url)._value[0].path;
        }
      }
    });

    this.eventBus.on('preset:loading').subscribe(
      (event: IEvent) => {
        this.loading = event.value[0];
      }
    );
    this.eventBus.on('preset:saved').subscribe(
      (event: IEvent) => {
        this.load();
      }
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.defaultSubject.unsubscribe();
    this.eventBus.release();
  }

  ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }

  edit(row): void {
    this.router.navigate([ './' + row.id ], {
      relativeTo: this.route
    });
    this.currentPreset = row.id;
  }
}
